export default (products, pnrModel) => {
  const { cart } = pnrModel;
  const { travelerCollection } = cart;

  let clubpremierIDP = null;
  let balance = null;
  let metricPointsValue = 0;

  if (travelerCollection) {
    clubpremierIDP = travelerCollection[0].ManageUserProfileAccount.account.frequentFlyerNumber;
    balance = travelerCollection[0].ManageUserProfileAccount.account.balance;

    travelerCollection.map(travelerCollectionItem => {
      const ancillaryPath = travelerCollectionItem.ancillaries.ancillaries;

      if (ancillaryPath) {
        ancillaryPath.map(ancillariesItem => {
          if (ancillariesItem.ancillary && ancillariesItem.isPaid === false) {
            if (ancillariesItem.ancillary.redeemedCP === true) {
              if (ancillariesItem.ancillary.currencyPerLegArray !== undefined) {
                metricPointsValue += ancillariesItem.ancillary.getTotalCPPointsPerLeg(ancillariesItem.legCode);
              }
            }
          }
        });
      }
    });
  }

  return clubpremierIDP !== null ? {
    event: 'productClick',
    ticketNumber: '',
    pointsValue: metricPointsValue,
    pointsCP: balance,
    clubpremierIDP: clubpremierIDP,
    ecommerce: {
      click: {
        actionField: {
          list: 'Baggage MYB',
        },
        products: products,
      },
    },
  } : {
    event: 'productClick',
    ecommerce: {
      click: {
        actionField: {
          list: 'Baggage MYB',
        },
        products: products,
      },
    },
  };
};
